import { Link, RouteComponentProps } from "@reach/router";
import { Card, Col, Row, Typography } from "antd";
import React from "react";
import { Trans } from "react-i18next";

const styles = {
  constainer: {
    height: "100vh",
    backgroundColor: "#501D3D",
    paddingTop: 50,
  },
  content: {
    maxWidth: 600,
    margin: "auto",
    marginTop: 50,
    padding: 20,
    borderRadius: 10,
  },
  text: {
    color: "white",
    textAlign: "center" as const,
  },
  buttons: {
    textAlign: "center" as const,
  },
};

interface Props extends RouteComponentProps {}

const AccountDelete = (props: Props) => {
  return (
    <Row justify="center" style={styles.constainer}>
      <Col>
        <Typography.Title style={styles.text}>Hack Harvest</Typography.Title>
        <Typography.Paragraph style={styles.text}>
          <Trans>Workorder app for Hack Harvest</Trans>
        </Typography.Paragraph>
        <Card style={styles.content}>
          <Typography.Paragraph>
            <Trans>
              If you wish to initiate the deletion of your account, kindly
              follow the outlined procedure below:
            </Trans>
            <ol>
              <li>
                <Trans>
                  Compose an email to{" "}
                  <Link to="mailto:info@hackharvest.com">
                    info@hackharvest.com
                  </Link>
                  .
                </Trans>
              </li>
              <li>
                <Trans>State that you wish to delete your account.</Trans>
              </li>
              <li>
                <Trans>
                  Include your full name and the email address associated with
                  your account.
                </Trans>
              </li>
            </ol>
            <Trans>
              It is important to know that the removal of your account is an
              irreversible process. Once completed, you will no longer have
              access to sign in and submit new work orders. However, please be
              informed that any work orders submitted prior to the account
              deletion will remain stored in our records. If you have any
              further inquiries or require assistance, feel free to contact us.
            </Trans>
          </Typography.Paragraph>
        </Card>
      </Col>
    </Row>
  );
};

export default AccountDelete;
